import React from "react";
import { CcIconEmpty } from "../../icons";
import { CcButton } from "../mui";
import { cx } from "../utils";

/**
 * CcEmptyState — centered empty placeholder (Zen editorial).
 * Uses Carecentre typography tokens for title and description.
 */
const CcEmptyState = ({
  icon,
  showIcon = true,
  title,
  description,
  action,
  actionLabel,
  onAction,
  actionVariant = "primary",
  className,
}) => {
  const resolvedIcon = icon ?? <CcIconEmpty size={28} />;
  const resolvedAction =
    action ??
    (actionLabel ? (
      <CcButton variant={actionVariant} size="md" onClick={onAction}>
        {actionLabel}
      </CcButton>
    ) : null);

  return (
    <div className={cx("cc-empty-state", className)}>
      <div className="cc-empty-state__inner">
        {showIcon && resolvedIcon ? (
          <div className="cc-empty-state__icon" aria-hidden="true">
            {resolvedIcon}
          </div>
        ) : null}
        {title ? <h3 className="cc-empty-state__title">{title}</h3> : null}
        {description ? (
          <p className="cc-empty-state__description">{description}</p>
        ) : null}
        {resolvedAction ? (
          <div className="cc-empty-state__action">{resolvedAction}</div>
        ) : null}
      </div>
    </div>
  );
};

export default CcEmptyState;
